export default "__VITE_ASSET__bKBo5TUt__"